import { useParams } from "react-router-dom";

import { RuleWizardProvider } from "../../providers/RuleWizardProvider";

import RuleWizard from "./RuleWizard";

export default function RuleWizardWithProvider() {
	const { id } = useParams();
	return (
		<RuleWizardProvider editedId={id}>
			<RuleWizard />
		</RuleWizardProvider>
	);
}